import service from "../service/service";
import { AUTH_ENDPOINTS } from "./authConfig";
import { clearAuth } from "./authSlice";

export const logoutUser = () => async (dispatch, getState) => {
  const refreshToken = getState()?.auth?.refreshToken;

  try {
    if (refreshToken) {
      await service.post(AUTH_ENDPOINTS.logout, {
        refresh: refreshToken,
      });
    }
  } catch (error) {
    console.error("Logout API Error:", error);
  } finally {
    dispatch(clearAuth());
  }
};
